<template functional>
  <div class="sidebar-nav">
    <!--
        @slot To insert sidebar nav items -->
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SidebarNav'
}
</script>

<style lang="scss" scoped>
.sidebar-nav {
  position: absolute;
  width: 88%;
  top: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
  border-right: 2px solid $black;
}
</style>
